import { render } from "./App.vue?vue&type=template&id=056d5a3e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=056d5a3e&lang=sass"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__